import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, catchError, finalize, Observable, of } from 'rxjs';
import { PbxAccountButtonTemplatesService as PbxAccountButtonTemplatesApiService } from '../../../../../../../api/services/pbx-account-button-templates.service';
import {
  BaseGridRequest,
  PbxAccountButtonTemplateListModel,
  PbxAccountButtonTemplatesGridResponse,
} from '../../../../../../../api/models';

export class DeviceButtonTemplatesDatasource implements DataSource<PbxAccountButtonTemplateListModel> {
  constructor(private readonly _deviceButtonTemplatesApiService: PbxAccountButtonTemplatesApiService) {}

  public readonly dataSubject = new BehaviorSubject<any[]>([]);

  private readonly _dataTotalSubject = new BehaviorSubject<number>(0);
  private readonly _loadingSubject = new BehaviorSubject<boolean>(true);

  public readonly loading$ = this._loadingSubject.asObservable();
  public readonly dataCount$ = this._dataTotalSubject.asObservable();

  connect(
    collectionViewer: CollectionViewer,
  ): Observable<PbxAccountButtonTemplateListModel[] | ReadonlyArray<PbxAccountButtonTemplateListModel>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this._loadingSubject.complete();
    this._dataTotalSubject.complete();
  }

  public currentPageData(): PbxAccountButtonTemplateListModel[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: BaseGridRequest): void {
    console.log('query tags');
    this._loadingSubject.next(true);

    this._deviceButtonTemplatesApiService
      .pbxAccountButtonTemplatesGetButtonTemplatesGrid({ body: state })
      .pipe(
        catchError(() => of({ data: [], total: 0 })),
        finalize(() => this._loadingSubject.next(false)),
      )
      .subscribe((response: PbxAccountButtonTemplatesGridResponse) => {
        this._dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      });
  }
}
